// extracted by mini-css-extract-plugin
export default {"messages_wrapper":"CreateDefaultMessage_messages_wrapper__FeQE8","footer":"CreateDefaultMessage_footer__JiCxE"};